import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

export const getCookieDetails = () => {
  try {
    const authCookie = Cookies.get("Authorization");
    if (authCookie) {
      const decodedCookie = jwtDecode(authCookie || "");
      const expirationTime = decodedCookie?.exp ? decodedCookie.exp * 1000 : 0; // JWT stores 'exp' in seconds, so convert to milliseconds
      const currentTime = new Date().getTime();
      if (expirationTime < currentTime) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};
